"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenudottedFill;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function MenudottedFill(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "menudotted-fill"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 50,
    cy: 50,
    r: 8
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 50,
    cy: 18,
    r: 8
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 50,
    cy: 82,
    r: 8
  }))));
}